import { Component, OnInit, Input, TemplateRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { OfferService } from '../../../shared/providers/offer.service';
import { IOfferDocsOutputModel } from '../../../shared/models/OfferDetailOutputModel';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { IFileUpload, IPropertyFileUpload } from '../../../shared/models/fileupload';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../../../shared/providers/common.service';
import { LookUp } from '../../../shared/enum/enum';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';



//import { saveAs } from 'file-saver';

@Component({
  selector: 'app-PortfolioFiles-Upload',
  templateUrl: './PortfolioFiles-Upload.component.html'
})

export class PortfolioFilesUploadComponent implements OnInit {

  LeadOffersDocsList: IOfferDocsOutputModel[];
  docCategories: ILookUp[];
  errorMessage: string;
  documentId: number;
  user: any;
  showRemoveButton: boolean = false;
  errorMessageForDocs: string;
  selectedFiles: string[] = [];
  selectedFilesForDocs: string[] = [];
  inputFileUpload = {} as IFileUpload;
  clearFiles: number = 0;
  modalRef: BsModalRef;
  @Input() inputOfferGuid: string = "";
  @Input() propertyId: number = 0;
  @Input() BackgroundFileStoring: number = 0;
  @Input() fromDealMaking: boolean = false;
  @Input() source: string = 'MyPortfolio';
  @Output() fileUploaded = new EventEmitter();
  @Input() modalRefUpload: BsModalRef;
  uploadedFiles: IPropertyFileUpload[] = [];
  fileExtensionType = 'document';
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  fileUploadType = 'multiple';
  accordianLeadOfferDoclst = [];
  filterOfferList = [];
  IsFileUploadConfirmed: boolean = false;
  @Input() UserGuid: string = '0000';
  portfolioProperty: any[];
  @ViewChild('UploadConfirmation') uploadConfirmation: TemplateRef<any>;
  modalRefuploadConfirmation: BsModalRef;
  constructor(private modalService: BsModalService, private authService: AuthenticationService, private router: Router, private _auth0: AuthService, private offerService: OfferService, private _toastService: ToastService, private http: HttpClient, private Loader: LoaderService, private Toast: ToastService, private _fileUploadService: FileUploadService, public Validation: ValidationService, private _propertyManagementService: PropertyManagementService, private _commonService: CommonService) { }
  offerGuid = '';
  ngOnInit() {
    this.user = this.authService.user;
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000';
    this.offerGuid = this.inputOfferGuid;
    this._propertyManagementService.getFileCategories(6808).subscribe(response => {
      this.docCategories = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });
    this.loadprincipalProperties();
  }

  filesCollection = [];
  categoryList = [];

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.errorMessage = null;
    this.selectedFiles = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    this.selectedFiles.forEach(item => {
      var ext = item["name"].toUpperCase().split('.').pop() || item["name"];
      if (item["type"] === 'application/pdf') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item,
          section: '',
          isPortfolioProperty: 0,
          propertyId: this.source == 'MyPortfolio' ? 0 : this.propertyId,
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'application/vnd.ms-excel' ||
        item["type"] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item,
          section: '',
          isPortfolioProperty: 0,
          propertyId: this.source == 'MyPortfolio' ? 0 : this.propertyId,
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'application/msword' ||
        item["type"] === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item,
          section: '',
          isPortfolioProperty: 0,
          propertyId: this.source == 'MyPortfolio' ? 0 : this.propertyId,
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'text/plain') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item,
          section: '',
          isPortfolioProperty: 0,
          propertyId: this.source == 'MyPortfolio' ? 0 : this.propertyId,
        }
        this.filesCollection.push(fileObj);
      }
      else if ((item["type"] === 'image/x-dwg') || (ext === "DWG")) {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item,
          section: '',
          isPortfolioProperty: 0,
          propertyId: this.source == 'MyPortfolio' ? 0 : this.propertyId,
        }
        this.filesCollection.push(fileObj);
      }
      else {
        this._toastService.addToast({
          title: 'Error Extension',
          msg: `Please upload .pdf/.xlsx/.xls/.docx/.doc/.txt/.dwg files`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    });
  }
  removeImage(fileIndex: number, event: any) {
    if (fileIndex > -1) {
      //this.selectedFiles.splice(fileIndex, 1);
      this.filesCollection.splice(fileIndex, 1);
    }
  }
  onFilesClear() {
    this.clearFiles++;
    this.selectedFiles = [];
    this.filesCollection = [];
  }
  openModal(template: TemplateRef<any>, classes: any, documentId: number, i: any) {

    this.modalRef = this.modalService.show(template, { class: classes });
    this.documentId = documentId;
  }
  onRemoveDocument() {
    this._propertyManagementService.deleteDocument(this.documentId, this.user.Id).subscribe(response => {
      if (response.toString() === 'true') {
        this._toastService.addToast({
          title: 'Success',
          msg: 'Document deleted!',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });



      } else {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'Image could not be deleted',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    });

  }

  uploadFiles() {
    this.Loader.display(true);
    let valid = true;
    let objectTypeId = 0;
    //if (this.modalRefuploadConfirmation !== undefined) {
    //  this.modalRefuploadConfirmation.hide();
    //}
    for (let i = 0; i < this.filesCollection.length; i++) {
      if (this.filesCollection[i]["propertyId"] == -1) {
        this.filesCollection[i]["section"] = 'MyPortfolio';
      }
      else if (this.filesCollection[i]["propertyId"]>0) {
        this.filesCollection[i]["section"] = 'Property';
      }
      else if (this.filesCollection[i]["propertyId"] == 0 && this.filesCollection[i]["section"]=='') {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Please Select Property / Portfolio", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.Loader.display(false);
        valid = false;
        break;
      }
      if (parseInt(this.filesCollection[i]["category"]) === 0) {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Please Select Catogory", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.Loader.display(false);
        valid = false;
        break;
      }
      if (this.filesCollection[i]["section"] == 'Property') {
        if (parseInt(this.filesCollection[i]["propertyId"]) === 0) {
          this.Toast.addToast({ title: 'Error Occurred', msg: "Please Select Property", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.Loader.display(false);
          valid = false;
          break;
        }
        if (this.source != 'MyPortfolio') {
          objectTypeId = 305;
        }
        else {
          let _propertyId = this.filesCollection[i]["propertyId"];
          let propertyType = this.portfolioProperty.find(p => p.Id == _propertyId).PropertyType;
          if (propertyType != null && propertyType != undefined) {
            objectTypeId = 305  ;
          }
        }
      }
      else {
        this.filesCollection[i]["propertyId"] = -1;
        objectTypeId = 324;
      }
    }
    if (valid) {
    /*  if (this.IsFileUploadConfirmed) {*/
        let url = this.router.url;
       /* this.IsFileUploadConfirmed = false;*/
        this.filesCollection.forEach(item => {
          let fileToUpload = [];
          fileToUpload.push(item["file"]);
          this.uploadedFiles.push({
            id: 0,
            objectId: (item["propertyId"] > 0 && item["propertyId"] != null && item["propertyId"] != undefined) ? item["propertyId"] : 0,
            type: 'Documents',
            documentName: item["name"],
            fileCategoryId: item["category"],
            objectTypeId: (item["propertyId"] > 0 && item["propertyId"] != null && item["propertyId"] != undefined) ? 305 : 324,
            FileContent: null,
            isDefault: false,
            ImageGuid: this.newGuid(),
            PropertyGuid: '',
            ImageStatus: '',
            fileToUpload: fileToUpload,
            sourceUrl: url,
            RefreshTab: 'MyPortfolio-Files',
            PrincipalPropertyType: (item["propertyId"] > 0 && item["propertyId"] != null && item["propertyId"] != undefined) ?  'Property' : 'Portfolio',
            PrincipalGuid:this.UserGuid
          });
          this.inputFileUpload.documentName = item["name"];
        });
        this.clearFiles++;
        if (this.uploadedFiles != null) {
          this.onFilesClear();
          this.Loader.display(false);
          this.imageupload();
          this.modalRefUpload.hide();
          this.Toast.addToast({ title: '', msg: "File uploads are in progress, please don't reload or close the website until complete.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'info' });
        }
      //}
      //else {
      //  this.Loader.display(false);
      //  this.IsFileUploadConfirmed = true;
      //  this.modalRefuploadConfirmation = this.modalService.show(this.uploadConfirmation, { class: 'deletemodal' });
      //}
    }
  }
  openAccordian(index) {
    if (index.Active == 1) {
      index.Active = 0;
    }
    else {
      index.Active = 1;
    }
  }
  imageupload() {
    localStorage.setItem('currentFileRefreshTab', 'MyPortfolio-Files');
    this._auth0.FileUpload(this.uploadedFiles);
    this.uploadedFiles = [];
  }
  toggle_child(data) {
    this.filterOfferList.map(item => {
      if (data === item) {
        item.showChild = !item.showChild;
      }
      else {
        item.showChild = false;
      }
    })
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  loadprincipalProperties() {
    this._propertyManagementService.getPrincipalPortfolioProperties(this.user.Id, this.UserGuid,'0000').subscribe(response => {
      if (response != null && response.length > 0) {
        this.portfolioProperty = response;
      }
    });
  }

  onSectionClick(section: string, file: any) {
    if (section != null && section != 'Property') {
      file
    }
  }

  CloseFile() {
    if (this.modalRefUpload != undefined) {
      this.modalRefUpload.hide();
    }
  }
}

